const ReportElementIdentifiers = {
    REPORT_MAIN: 'report_main',
    REPORT_DETAIL: 'report_detail'
};

export default ReportElementIdentifiers;
